import { apiClient } from '../_helpers';

export const tagGroupService = {
  getAll,
  getSelectList,
  getById,
  addTagGroup,
  updateTagGroup,
  deleteTagGroup
};

function getAll() {
  return apiClient('taggroups/')
  .get()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}

function getSelectList() {
  return apiClient('taggroups/selectlist')
  .get()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}

function getById(id) {
  return apiClient('taggroups/')
  .get(`${id}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}

function addTagGroup(tagGroup) {
  return apiClient('taggroups/')
  .post('',`${JSON.stringify(tagGroup)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function updateTagGroup(tagGroup) {
  return apiClient(`taggroups/${tagGroup.id}`)
  .put('',`${JSON.stringify(tagGroup)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function deleteTagGroup(tagGroup) {
  return apiClient(`taggroups/${tagGroup}`)
  .delete()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}